import React from "react";
import { Card, Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Testi1 from "../assets/testi_1.png";
import Testi2 from "../assets/testi_2.png";
import Testi3 from "../assets/testi_3.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
  {
    name: "Aravindan",
    title: "Founder of Mazhil",
    image: Testi1,
    text:
      "This one platform simplifies fundraising with user-friendly features like an intuitive interface, customizable tools, budget-friendly pricing, stellar customer support, and seamless integration.",
    rating: 5
  },
  {
    name: "Mathew Davick",
    title: "Founder of ABS",
    image: Testi2,
    text:
      "Ellan proved perfect for creating a professional website with its user-friendly interface and pre-designed blocks. Despite occasional compromises, Ellan streamlined web development.",
    rating: 5
  },
  {
    name: "Praveen Kumar",
    title: "Founder of Friends Trust",
    image: Testi3,
    text:
      "Featuring an intuitive drag-and-drop interface, affordable pricing, excellent support, and social media integration, this software is ideal for user-friendly fundraising.",
    rating: 5
  },
  {
    name: "Mathew Davick",
    title: "Founder of ABS",
    image: Testi2,
    text:
      "Ellan proved perfect for creating a professional website with its user-friendly interface and pre-designed blocks. Despite occasional compromises, Ellan streamlined web development.",
    rating: 5
  }
  // {
  //   name: "Praveen Kumar",
  //   title: "Founder of Friends Trust",
  //   image: Testi3,
  //   text:
  //     "Featuring an intuitive drag-and-drop interface, affordable pricing, excellent support, and social media integration, this software is ideal for user-friendly fundraising.",
  //   rating: 5
  // }
  // Add more testimonials as needed
];

const TestimonialScroller = () => {
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1
  };

  return (
    <div style={{ backgroundColor: "#ffba00", padding: "40px 0" }}>
      <Container>
        <h3 className="text-center mb-5 fw-bold">
          What Our Users and Partners Say
        </h3>

        <div className="testimonial-scroll">
          <Slider {...settings}>
            {testimonials.map((item, index) =>
              <Card key={index} className="testimonial-card me-3">
                <Card.Body>
                  <div className="text-warning" style={{ fontSize: "40px" }}>
                    {"★".repeat(item.rating)}
                  </div>
                  <Card.Text>
                    {item.text}
                  </Card.Text>
                </Card.Body>
                <Card.Footer className="bg-white border-0 d-flex align-items-center">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="rounded-circle me-3"
                    width="50"
                    height="50"
                  />
                  <div>
                    <div className="fw-bold text-primary">
                      {item.name}
                    </div>
                    <div className="text-muted small">
                      {item.title}
                    </div>
                  </div>
                </Card.Footer>
              </Card>
            )}
          </Slider>
        </div>
      </Container>

      {/* Inline Styles */}
      <style>{`
.slick-slide {
  padding: 0 10px;
}
      
      `}</style>
    </div>
  );
};

export default TestimonialScroller;
